module.exports = __webpack_public_path__ + "img/asnLpnReceiptS1Page.2e9a53dc.png";